import Organizations_Organizations_DashboardPage from "@Organizations/OrganizationUnits/Pages/DashboardPage.vue";

import Organizations_Organizations_Admin_CreateOrganizationPage from "@Organizations/OrganizationUnits/Pages/Admin/CreateOrganizationPage.vue";
import Organizations_Organizations_Admin_DashboardPage from "@Organizations/OrganizationUnits/Pages/Admin/DashboardPage.vue";
import Organizations_Organizations_Admin_ManageBrandingPage from "@Organizations/OrganizationUnits/Pages/Admin/ManageBrandingPage.vue";
import Organizations_Organizations_Admin_ManageFeaturesPage from "@Organizations/OrganizationUnits/Pages/Admin/ManageFeaturesPage.vue";
import Organizations_Organizations_Admin_ManageOrganizationPage from "@Organizations/OrganizationUnits/Pages/Admin/ManageOrganizationPage.vue";
import Organizations_Organizations_Admin_ManageOrganizationsPage from "@Organizations/OrganizationUnits/Pages/Admin/ManageOrganizationsPage.vue";
import Organizations_Organizations_Admin_ManageOrganizationSsoPage from "@Organizations/OrganizationUnits/Pages/Admin/ManageOrganizationSsoPage.vue";
import Organizations_Organizations_Admin_SearchOrganizationPage from "@Organizations/OrganizationUnits/Pages/Admin/SearchOrganizationPage.vue";
import Organizations_Organizations_Admin_SystemStatsPage from "@Organizations/OrganizationUnits/Pages/Admin/SystemStatsPage.vue";

export const routes = [
    // pages
    {
        path: "/organizations/:token",
        component: Organizations_Organizations_DashboardPage
    },

    // admin pages
    {
        path: "/admin/organizations/create",
        component: Organizations_Organizations_Admin_CreateOrganizationPage
    },
    {
        path: "/admin/organizations/dashboard/:tid",
        component: Organizations_Organizations_Admin_DashboardPage
    },
    {
        path: "/admin/organizations/features/:tid",
        component: Organizations_Organizations_Admin_ManageFeaturesPage
    },
    {
        path: "/admin",
        component: Organizations_Organizations_Admin_ManageOrganizationsPage
    },
    {
        path: "/admin/organizations/manage",
        component: Organizations_Organizations_Admin_ManageOrganizationsPage
    },
    {
        path: "/admin/organizations/manage/:tid",
        component: Organizations_Organizations_Admin_ManageOrganizationPage
    },
    {
        path: "/admin/organizations/manage/branding/:tid",
        component: Organizations_Organizations_Admin_ManageBrandingPage
    },
    {
        path: "/admin/organizations/manage/sso/:tid",
        component: Organizations_Organizations_Admin_ManageOrganizationSsoPage
    },
    {
        path: "/admin/organizations/search/:tid/:searchPhrase",
        component: Organizations_Organizations_Admin_SearchOrganizationPage
    },
    {
        path: "/admin/organizations/systemstats",
        component: Organizations_Organizations_Admin_SystemStatsPage
    }
]
